import {ref} from "vue";
import {resendCode} from "../api";
import {useI18n} from "vue-i18n";
import AnalyticsService from "@emcd-shared/analytics-service";
import {TYPES_2FA_OTP} from '@/packages/auth-service/common/const'

const currentMethod = ref(null);
const numberOfInputs = ref(null);
const nextMethod = ref(null);
const isResendLoading = ref(false);

export function use2FA(props, emit) {
    const code = ref("");
    const isLoading = ref(false);
    const clientError = ref("");
    const serverError = ref("");
    let serverErrorTimeout = null;

    const {t} = useI18n();

    const setServerError = (message) => {
        serverError.value = message;
        if (serverErrorTimeout) clearTimeout(serverErrorTimeout);
        serverErrorTimeout = setTimeout(() => {
            serverError.value = "";
            serverErrorTimeout = null;
        }, 2000);
    };

    const setDetails = (details = {next: null, number: null, method: null}) => {
        currentMethod.value = details.method;
        numberOfInputs.value = currentMethod.value === TYPES_2FA_OTP.GOOGLE ? 6 : details.number;
        nextMethod.value = details.next;
    };

    const resendSms = async (secretKey, flow) => {
        try {
            isResendLoading.value = true;
            const response = await resendCode(secretKey, flow);

            setDetails({
                number: response.current_two_fa_code_len,
                next: response.next_two_fa_method_type,
                method: response.current_two_fa_method_type,
            });
        } catch (error) {
            if (error?.response?.data?.code) {
                setServerError(t(error?.response?.data?.code));
            }
        } finally {
            isResendLoading.value = false;
        }
    };

    const onSubmit = async () => {
        try {
            if (isLoading.value) {
                return;
            }

            isLoading.value = true;
            if (code.value.length !== numberOfInputs.value) {
                clientError.value = t("invalid code");
                return;
            }

            if (props.onValidate) {
                const response = await props.onValidate(code.value);
                emit("resolve", response);
            } else {
                emit("resolve", code.value);
            }
        } catch (error) {
            if (error?.response?.data?.code) {
                setServerError(t(error?.response?.data?.code));
            } else {
                setServerError(t("2faModal | invalidCode"));
            }
            code.value = "";
            AnalyticsService.error(error);
        } finally {
            isLoading.value = false;
        }
    };

    const onReset = () => {
        clientError.value = "";
        serverError.value = "";
        if (serverErrorTimeout) {
            clearTimeout(serverErrorTimeout);
            serverErrorTimeout = null;
        }
    };

    return {
        code,
        isLoading,
        clientError,
        serverError,
        currentMethod,
        numberOfInputs,
        nextMethod,
        isResendLoading,
        onSubmit,
        onReset,
        resendSms,
        setDetails,
    };
}
